import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/reset.css';
import "./styles/App.css";
import './styles/scroller.css';

import { Provider } from 'react-redux'
import { store } from './store';

window.store = store;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
